export const SCREEN_SIZE = {
  xs: "0px",
  sm: "600px",
  md: "900px",
  lg: "1200px",
  xl: "1536px",
};

export const HTTPS = {
  OK: 200,
  INTERNAL_SERVER_ERROR: 500,
  PAGE_NOT_FOUND: 404,
};

export const SECTION = {
  type: "section",
  id: "",
  list_style: "none",
  title: "Section",
  align: "left",
  sectionMark: 0,
  lableCount: 0,
  hasOr: false,
  showMark: true,
  children: [],
};

export const LABEL = {
  type: "label",
  id: "",
  value: 0,
  list_style: "none",
  marks: 0,
  title: "Label",
  align: "left",
  qtype: 0,
  questionCount: 0,
  labelMark: 0,
  mandatoryQuestion: 0,
  hasOr: false,
  showMark: true,
  children: [],
  continueSequence: false,
  boldNumbers: false,
  sameNumberForOR: false,
};

export const QUESTION = {
  type: "question",
  id: "",
  labelId: "",
  list_style: "decimal",
  marks: 0,
  title: "Question",
  align: "left",
  qtype: null,
  showMark: true,
  chapter_list: [
    {
      check: [],
      list: [],
    },
  ],
  que_types: [
    {
      check: [],
      list: [],
    },
  ],
  difficulty_list: [
    {
      check: [],
      list: [],
    },
  ],
  importance_list: [
    {
      check: [],
      list: [],
    },
  ],
};

export const OR = {
  type: "or",
  id: "",
  list_style: "none",
  marks: 0,
  title: "<b>OR</b>",
  align: "justify",
  qtype: null,
};

export const scoreList = [
  { id: 0, name: "0" },
  { id: 1, name: "1" },
  { id: 2, name: "2" },
  { id: 3, name: "3" },
  { id: 4, name: "4" },
  { id: 5, name: "5" },
  { id: 6, name: "6" },
  { id: 7, name: "7" },
  { id: 8, name: "8" },
  { id: 9, name: "9" },
  { id: 10, name: "10" },
  { id: 11, name: "11" },
  { id: 12, name: "12" },
  { id: 13, name: "13" },
  { id: 14, name: "14" },
  { id: 15, name: "15" },
  { id: 16, name: "16" },
  { id: 17, name: "17" },
  { id: 18, name: "18" },
  { id: 19, name: "19" },
  { id: 20, name: "20" },
  { id: 21, name: "21" },
  { id: 22, name: "22" },
];

export const MARKS = [
  {
    id: 0,
    name: "All marks",
  },
  {
    id: 1,
    name: "1",
  },
  {
    id: 2,
    name: "2",
  },
  {
    id: 3,
    name: "3",
  },
  {
    id: 4,
    name: "4",
  },
  {
    id: 5,
    name: "5",
  },
  {
    id: 6,
    name: "6",
  },
  {
    id: 7,
    name: "7",
  },
  {
    id: 8,
    name: "8",
  },
  {
    id: 9,
    name: "9",
  },
  {
    id: 10,
    name: "10",
  },
];

export const STEPS = [
  { name: "Blueprint", id: 1 },
  { name: "Question Selection", id: 2 },
  { name: "Header Design", id: 3 },
  { name: "Preview", id: 4 },
];

export const PAGE_LIMIT = 10;
export const PAGE_LIMIT_OPTIONS = [10, 25, 50, 100];

export const CONSTANTS = {
  SECURE_TEXT_ROUNDS: 6,
  SECURE_ENC_DEC_KEY:
    "WFGCbvIqWaWTmTUKRos4MZK3McH9AB4tgr1YtSf8WpKXxDixu9lzBvbPBiY2rVOH",
};

export const MASTERQUESTIONTYPE = [
  { name: "Textbox", id: "Textbox" },
  { name: "Radio", id: "Radio" },
  { name: "Dropdown", id: "Dropdown" },
  { name: "DropdownMultiSelect", id: "DropdownMultiSelect" },
];

export const PROJECT_TYPES = [
  { id: "66b364590691cdd5b45e4819", type: "residential" },
  { id: "66b364590691cdd5b45e481a", type: "bungalow" },
  { id: "66b364590691cdd5b45e481b", type: "plotting" },
  { id: "66b364590691cdd5b45e481c", type: "commercial" },
  { id: "66b364590691cdd5b45e481d", type: ["residential, commercial"] },
  { id: "66b364590691cdd5b45e481e", type: "plotting" },
  { id: "66b364590691cdd5b45e481f", type: "plotting" },
];

export const DOC_TYPE_SLUG = [
  {
    id: 1,
    name: "Pan Card",
    param_name: "pancard",
  },
  {
    id: 2,
    name: "Election Card",
    param_name: "electioncard",
  },
  {
    id: 3,
    name: "Passport",
    param_name: "passport",
  },
  {
    id: 4,
    name: "Aadhar Card",
    param_name: "adharcard",
  },
];

export const MODULES = {
  DEVELOPER: {
    MODULE_ID: "66ab414b1a0b5c14f7dc4338",
    MY_SITES: {
      MODULE_ID: "66ab47d7c2a9eb3782f7a8e6",
      UNITS: { MODULE_ID: "66b480af5f887154cdcf1d7c" },
      MEMBERS: {
        MODULE_ID: "66b480bd5f887154cdcf1d7f",
        MEMBER_DOCS: { MODULE_ID: "66e27cc9ce6ee3a60d06681a" },
      },
      SITE_DOCUMENTS: { MODULE_ID: "66b480d85f887154cdcf1d82" },
    },
    MY_DOCUMENTS: { MODULE_ID: "66ab416d1a0b5c14f7dc433c" },
  },
  PROJECT_SITE: {
    MODULE_ID: "66b47d7087861e62a7240fce",
    MY_SITES: {
      MODULE_ID: "66b47d9987861e62a7240fd1",
      UNITS: { MODULE_ID: "66c5e780ce620cbc419661e1" },
      MEMBERS: {
        MODULE_ID: "66c5e76fce620cbc419661de",
        MEMBER_DOCS: { MODULE_ID: "66e27c57ce6ee3a60d06674a" },
      },
      SITE_DOCUMENTS: { MODULE_ID: "66c5e79cce620cbc419661e4" },
    },
    MY_DOCUMENTS: { MODULE_ID: "66b47da687861e62a7240fd4" },
  },
  MEMBERS: {
    MODULE_ID: "66b47e1d87861e62a7240fe2",
    PROJECT_MEMBERS: {
      MODULE_ID: "66b47e3487861e62a7240fe5",
      MEMBER_DOCS: {
        MODULE_ID: "66fb972798d6ad4805cb3d47",
      },
    },
  },
  USER_ACCESS: {
    MODULE_ID: "66ab6978e01fcd1b43dd907e",
  },
};
